/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const DeleteRestrictionChecksRequestDTOMarketplaceEnum = {
    UnitedStates: 'UNITED_STATES',
    Brazil: 'BRAZIL',
    Canada: 'CANADA',
    Mexico: 'MEXICO',
    Australia: 'AUSTRALIA',
    Japan: 'JAPAN',
    India: 'INDIA',
    Singapore: 'SINGAPORE',
    Germany: 'GERMANY',
    Spain: 'SPAIN',
    France: 'FRANCE',
    Italy: 'ITALY',
    Netherlands: 'NETHERLANDS',
    Belgium: 'BELGIUM',
    Poland: 'POLAND',
    Sweden: 'SWEDEN',
    UnitedKingdom: 'UNITED_KINGDOM',
    Ireland: 'IRELAND',
    UnitedArabEmirates: 'UNITED_ARAB_EMIRATES',
    Egypt: 'EGYPT',
    SaudiArabia: 'SAUDI_ARABIA',
    All: 'ALL'
};
/**
 * Check if a given object implements the DeleteRestrictionChecksRequestDTO interface.
 */
export function instanceOfDeleteRestrictionChecksRequestDTO(value) {
    return true;
}
export function DeleteRestrictionChecksRequestDTOFromJSON(json) {
    return DeleteRestrictionChecksRequestDTOFromJSONTyped(json, false);
}
export function DeleteRestrictionChecksRequestDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'selectAll': json['selectAll'] == null ? undefined : json['selectAll'],
        'ids': json['ids'] == null ? undefined : json['ids'],
        'marketplace': json['marketplace'] == null ? undefined : json['marketplace'],
    };
}
export function DeleteRestrictionChecksRequestDTOToJSON(json) {
    return DeleteRestrictionChecksRequestDTOToJSONTyped(json, false);
}
export function DeleteRestrictionChecksRequestDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'selectAll': value['selectAll'],
        'ids': value['ids'],
        'marketplace': value['marketplace'],
    };
}
